export const throwIfMissing = name => {
  throw new Error(`Missing parameter: ${name}`);
};